import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RegistrationData, RegistrationState, RegistrationStep } from '@/types/auth/Auth';
import { getNextStep, getPrevStep } from '@/types/auth/Auth';

const initialState: RegistrationState = {
  step: 'otp',
  data: {},
  loading: false,
  error: undefined,
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    nextStep(state) {
      const next = getNextStep(state.step);
      if (next !== null) {
        state.step = next;
      }
    },
    prevStep(state) {
      const prev = getPrevStep(state.step);
      if (prev !== null) {
        state.step = prev;
      }
    },
    setStep(state, action: PayloadAction<RegistrationStep>) {
      state.step = action.payload;
    },
    setData(state, action: PayloadAction<Partial<RegistrationData>>) {
      state.data = { ...state.data, ...action.payload };
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | undefined>) {
      state.error = action.payload;
    },
    resetRegistration(state) {
      state.step = 'otp';
      state.data = {};
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const { nextStep, prevStep, setStep, setData, setLoading, setError, resetRegistration } =
  registrationSlice.actions;

export default registrationSlice.reducer;
